import { payloadBool } from "helpers/utils/utilities";
import { useSelector } from "react-redux";
import { REDUCER_TYPES } from "store";
import REQUEST from "store/api";
import { ENDPOINTS } from "store/api/endpoints";
import { serializeObject } from "store/api/utils";
import { resolveResponse } from "store/api/utils";

const useCareers = () => {
  const { language, token } = useSelector((state) => state[REDUCER_TYPES.AUTH]);

  const headers = {
    Authorization: "Bearer " + token,
  };

  //FETCH CAREER/SKILLS RECOMMENDATIONS
  const fetchRecommendations = async (filters = {}) => {
    const client = new REQUEST();
    const res = await client.get(
      `${
        ENDPOINTS.CAREER_EXPLORER
      }/recommendations?language=${language}&${serializeObject(filters)}`,
      {},
      headers,
      Function.prototype
    );
    if (res?.data?.data) {
      return res?.data?.data;
    }
    return [];
  };

  //FETCH CAREERS
  const fetchCareers = async (filters = {}) => {
    const client = new REQUEST();
    const res = await client.get(
      `${ENDPOINTS.CAREER_EXPLORER}/${
        ENDPOINTS.CAREER
      }?language=${language}&${serializeObject(filters)}`,
      {},
      headers,
      Function.prototype
    );
    if (res?.data?.data) {
      return res?.data?.data;
    }
    return [];
  };

  //FETCH SKILLS
  const fetchSkills = async (filters = {}) => {
    const client = new REQUEST();
    const res = await client.get(
      `${ENDPOINTS.CAREER_EXPLORER}/${
        ENDPOINTS.SKILL
      }?language=${language}&${serializeObject(filters)}`,
      {},
      headers,
      Function.prototype
    );
    if (res?.data?.data) {
      return res?.data?.data;
    }
    return [];
  };

  //FETCH CAREER DETAILS
  const fetchCareer = async (id) => {
    if (!id) return;
    const client = new REQUEST();
    const res = await client.get(
      `${ENDPOINTS.CAREER_EXPLORER}/${ENDPOINTS.CAREER}/${id}?language=${language}`,
      {},
      headers,
      Function.prototype
    );
    if (res?.data?.data) {
      return res?.data?.data;
    }
  };

  //FETCH SKILL DETAILS
  const fetchSkill = async (id) => {
    if (!id) return;
    const client = new REQUEST();
    const res = await client.get(
      `${ENDPOINTS.CAREER_EXPLORER}/${ENDPOINTS.SKILL}/${id}?language=${language}`,
      {},
      headers,
      Function.prototype
    );
    if (res?.data?.data) {
      return res?.data?.data;
    }
  };

  //GET SAVED CAREERS
  const fetchSaved = async (filters = {}, isSkill) => {
    const client = new REQUEST();
    const res = await client.get(
      `${ENDPOINTS.CAREER_EXPLORER}/${
        isSkill ? ENDPOINTS.SKILL : ENDPOINTS.CAREER
      }/saved?language=${language}&${serializeObject(filters)}`,
      {},
      headers,
      Function.prototype
    );
    if (res?.data?.data) {
      return res?.data?.data;
    }
  };

  //GET PINNED CAREERS
  const fetchPinned = async (isSkill) => {
    const client = new REQUEST();
    const res = await client.get(
      `${ENDPOINTS.CAREER_EXPLORER}/${
        isSkill ? ENDPOINTS.SKILL : ENDPOINTS.CAREER
      }/pinned?language=${language}`,
      {},
      headers,
      Function.prototype
    );
    if (res?.data?.data) {
      return res?.data?.data;
    }
  };

  //SAVE CAREER OR SKILL
  const save = async (id, isSkill) => {
    if (!id) return;
    const onSuccess = (res) => resolveResponse(res);
    const client = new REQUEST();
    await client.post(
      `${ENDPOINTS.CAREER_EXPLORER}/${
        isSkill ? ENDPOINTS.SKILL : ENDPOINTS.CAREER
      }/${id}/${ENDPOINTS.ADD}?language=${language}`,
      {},
      headers,
      onSuccess
    );
  };

  //UNSAVE CAREER OR SKILL
  const unsave = async (id, isSkill) => {
    if (!id) return;
    const onSuccess = (res) => resolveResponse(res);
    const client = new REQUEST();
    await client.delete(
      `${ENDPOINTS.CAREER_EXPLORER}/${
        isSkill ? ENDPOINTS.SKILL : ENDPOINTS.CAREER
      }/${id}/${ENDPOINTS.DELETE}?language=${language}`,
      headers,
      onSuccess
    );
  };

  //PIN/UNPIN CAREER OR SKILL
  const pin = async (id, isSkill, value) => {
    if (!id) return;
    const onSuccess = (res) => resolveResponse(res);
    const client = new REQUEST();
    await client.post(
      `${ENDPOINTS.CAREER_EXPLORER}/${
        isSkill ? ENDPOINTS.SKILL : ENDPOINTS.CAREER
      }/${id}/pin?language=${language}&pinned=${value}`,
      {},
      headers,
      onSuccess
    );
  };

  return {
    fetchSaved,
    fetchPinned,
    save,
    unsave,
    pin,
    fetchRecommendations,
    fetchCareers,
    fetchSkills,
    fetchCareer,
    fetchSkill,
  };
};

export default useCareers;
